define('helpers/url-helper',['require','jquery','deparam'],function(require) {
  var $, deparam;
  $ = require("jquery");
  deparam = require("deparam");
  return {
    isAuthenticatedOptions: function(options) {
      var base, params, params_string, provider, _ref, _ref1, _ref2;
      _ref1 = (_ref = options.url) != null ? _ref.split("?") : void 0, base = _ref1[0], params_string = _ref1[1];
      params = $.deparam(params_string || "");
      provider = (options != null ? (_ref2 = options.headers) != null ? _ref2["Authorization-Provider "] : void 0 : void 0) || (params != null ? params.auth_provider : void 0);
      return (provider != null ? provider.toLowerCase() : void 0) === "evertrueauthtoken";
    },
    addNewToken: function(original_options, new_token) {
      var base, options, params, params_string, _ref, _ref1;
      options = $.extend(true, {}, original_options);
      _ref = options.url.split("?"), base = _ref[0], params_string = _ref[1];
      params = $.deparam(params_string || "");
      if ((_ref1 = options.headers) != null ? _ref1["Authorization"] : void 0) {
        options.headers["Authorization"] = new_token;
      } else if (params != null ? params.auth : void 0) {
        params.auth = new_token;
        options.url = base + "?" + $.param(params);
      }
      return options;
    }
  };
});

//# sourceMappingURL=url-helper.js.map
;
